import { render, staticRenderFns } from "./withdrawal_record.vue?vue&type=template&id=23380dec&scoped=true"
import script from "./withdrawal_record.vue?vue&type=script&lang=js"
export * from "./withdrawal_record.vue?vue&type=script&lang=js"
import style0 from "./withdrawal_record.vue?vue&type=style&index=0&id=23380dec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23380dec",
  null
  
)

export default component.exports